export function binary() {
    return window.JSVMP_BINARY;
}
